import { Button } from '@components/Button'
import { HeroIcon } from '@components/HeroIcon'
import { YStack, Text, useWindowDimensions, XStack } from 'tamagui'
import { CourseDescriptionModal } from './CourseDescriptionModal'
import { useState, useMemo } from 'react'
import RenderHtml from 'react-native-render-html'
import { useThemeColor } from '@hooks/useThemeColor'
import { media } from '@tamagui/config'

export function CourseDescription({ description }: { description: string }) {
  const textBodyColor = useThemeColor('text-body')
  const [openDesscriptionModal, setOpenDesscriptionModal] = useState(false)
  const { width, height } = useWindowDimensions()

  const maxHeight = height * 0.16

  const reducedDescription = useMemo(() => {
    if (description.slice(0, 600).includes('</a>')) {
      return description.slice(0, description.indexOf('</a>') + 150) + '...'
    }
    if (description.length > 300) {
      return description.slice(description.indexOf('>') + 1, 330) + '...'
    }
    return description
  }, [description])

  return (
    <>
      <YStack marginTop={24} maxHeight={maxHeight}>
        <Text
          numberOfLines={5}
          color="$text-body"
          ff="$mulishSemiBold"
          fontSize="$font-size-xs"
        >
          <RenderHtml
            contentWidth={width * 0.9}
            enableCSSInlineProcessing={false}
            source={{ html: reducedDescription }}
            baseStyle={{
              color: textBodyColor,
              maxWidth: width * 0.9,
            }}
          />
        </Text>
        <Button
          width="auto"
          alignSelf="flex-end"
          variant="primary"
          aria-label="Read more"
          link
          onPress={() => setOpenDesscriptionModal(true)}
        >
          <XStack
            alignItems="center"
            justifyContent="center"
            gap="$size.spacing-nano"
          >
            <HeroIcon icon={['fas', 'plus']} size={16} color="$accent" />
            <Text
              fontSize="$font-size-xxs"
              ff="$mulishRegular"
              color="$accent"
              position="relative"
              textDecorationLine="underline"
              top={media.gtSm ? -2 : -4}
            >
              Ler mais
            </Text>
          </XStack>
        </Button>
      </YStack>
      <CourseDescriptionModal
        open={openDesscriptionModal}
        onClose={() => setOpenDesscriptionModal(false)}
        description={description}
      />
    </>
  )
}
